const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

const formatTimestampToDate = timestamp => {
  const date = new Date(timestamp)
  const monthName = monthNames[date.getMonth()]
  return `${date.getDate()} ${monthName} ${date.getFullYear()}`
}

export default formatTimestampToDate
